import { ApiProperty } from "@nestjs/swagger";
import { IsNumber, IsOptional } from "class-validator";

export class EmployeeCodesRequest {
    @ApiProperty()
    employeeCodes: string[];
    @ApiProperty()
    username: string;
    @ApiProperty()
    employeeFreebiesId: number;
    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag: number;

    @ApiProperty()
    isActive: boolean;

    /**
     * 
     * @param employeeCodes 
     * @param username 
     */
    constructor(employeeCodes: string[], username: string) {
        this.employeeCodes = employeeCodes;
        this.username = username;
    }
}